import { Box, Grid } from "@mui/material";

import type { Project } from "../../types/project";
import ArchivedProjectCard from "../ArchivedProjectCard";

interface ArchivedProjectsGridProps {
  projects: Project[] | undefined;
  isLoading: boolean;
}

/** The Archived tab, shared by the classic and split layouts. */
export default function ArchivedProjectsGrid({ projects, isLoading }: ArchivedProjectsGridProps) {
  return (
    <Box sx={{ p: 3 }}>
      {isLoading ? (
        <Box>Loading archived projects...</Box>
      ) : !projects || projects.length === 0 ? (
        <Box sx={{ color: "text.secondary", mt: 2 }}>No archived projects.</Box>
      ) : (
        <Grid container spacing={2}>
          {projects.map((project) => (
            <Grid key={project.id}>
              <ArchivedProjectCard project={project} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
